import DocumentsCardSkeleton from "./DocumentCardSkelton";


const DocumentsCardSkeletonList = ({ count = 5 }) => {
  return (
    <div className="flex flex-col bg-white p-3 rounded-lg gap-3">
      {Array.from({ length: count }).map((_, index) => (
        <DocumentsCardSkeleton key={index} />
      ))}
    </div>
  );
};

export default DocumentsCardSkeletonList;